import React, { Component } from 'react';
import './index.scss';

class CustomInput extends Component {
    render() {
        return (
            <div className="custom-textarea">

                <label className="type-text -ch -md" htmlFor={this.props.id}>{this.props.label}</label>
                <textarea name="" id={this.props.id} placeholder={this.props.placeholder} defaultValue={this.props.value}
                onChange={e => {
                    e.persist();
                    if (this.props.onChange) {
                        this.props.onChange(e.target.value);
                    }
                }}></textarea>

                {
                    this.props.msg &&
                    <p className={'type-text -ch -xs msg ' + (this.props.status ? '-' + this.props.status : '')}>{this.props.msg}</p>
                }
            </div>
        );
    }
}

export default CustomInput;
